import React, { useState, useEffect } from 'react'
import { Box, NumberInput, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'

const defaultVal = {
  freight_value: 0,
  freight_value_order: 0,
}

const formValidation = {
  freight_value: {
    isError: false,
    message: ''
  },
  freight_value_order: {
    isError: false,
    message: ''
  }
}

const FormAdjustOrderFreight = ({ onCloseForm }) => {
  const { summary, general } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateFreight = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      freight_value: form.freight_value.toString(),
      freight_value_order: form.freight_value_order.toString()
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          notificationSuccess('Update Order Successfully', 'This data has been updated')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (general) {
      handleSetForm(general)
    }
    // eslint-disable-next-line
  }, [general])

  const handleSetForm = (value) => {
    const dataDetail = {
      freight_value: value.freightOriginalValue,
      freight_value_order: value.freightValue,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <NumberInput
          label="Origin Freight Cost"
          placeholder='Input origin freight cost'
          value={formData.freight_value}
          prefix={`${summary.goodsCurrency}  `}
          onChange={(val) => handleChangeForm('freight_value', val)}
          error={validationForm.freight_value.isError ? `${validationForm.freight_value.message}` : ''}
          thousandSeparator=","
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <NumberInput
          label="Freight Cost"
          placeholder='Input freight cost'
          value={formData.freight_value_order}
          prefix={`${summary.orderCurrency}  `}
          onChange={(val) => handleChangeForm('freight_value_order', val)}
          error={validationForm.freight_value_order.isError ? `${validationForm.freight_value_order.message}` : ''}
          thousandSeparator=","
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateFreight(formData)}>{general ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustOrderFreight